(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/my-orders/components/order.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/my-orders/components/order.js');
"use strict";


const {
  getOrderStatus
} = svs.ticket_partner.myOrders.utils;
const {
  DOWNLOAD
} = svs.ticket_partner.myOrders.constants.TEXTS.ORDER_STATES;
const {
  OrderTable,
  DownloadOrder
} = svs.ticket_partner.myOrders.components;
const Order = order => {
  const {
    ordered,
    state
  } = order;
  const status = getOrderStatus(state);
  const orderDate = svs.utils.date.SimpleDate(new Date(ordered));
  return React.createElement("div", {
    className: "u-text-left margin-top-1 margin-bottom-1"
  }, React.createElement("h2", null, orderDate), status === DOWNLOAD ? React.createElement(DownloadOrder, order) : React.createElement("p", null, status), React.createElement(OrderTable, order));
};
svs.ticket_partner.myOrders.components.Order = Order;

 })(window);